import React, { useEffect } from 'react';

export default function MyAccount(props) {
  return (
    <div></div>
  )
}